import React, { MutableRefObject, useEffect, useRef } from 'react'
import { scrollPageTo } from '@utils/genUtils'
import { svgs } from '@svg'
import ThemeButton from '@components/buttons/ThemeButton'
import styled from 'styled-components'
interface IProps {
  buttonOutlineColor?: string
  buttonHoverColor?: string
  id: string
  text: string
  alternateButton?: string
}
function CtaButton (props:any) {
  // `mini-card-2`
  const { id, text, buttonOutlineColor, alternateButton,
  buttonHoverColor } = props
  const checkoutContainer: MutableRefObject<null | HTMLElement> = useRef(null)
  useEffect(() => {
    checkoutContainer.current = document.getElementById(id)
  }, [])

  function buttonClick () {
    scrollPageTo(checkoutContainer, -125)
  }

  return (
    <div style={{zIndex: 3}}>
      {!alternateButton && <ThemeButton
        outlineColor={buttonOutlineColor}
        outlineHoverColor={buttonHoverColor}
        text={text}
        outline={true}
        clickHandler={buttonClick}/>}

      {alternateButton && <CustomButton
        onClick={buttonClick}
        className={`${alternateButton}`}>
        {text}
      </CustomButton>}

    </div>
  )
}

export default CtaButton

const CustomButton = styled.button`
  border: 0;
  border-radius: 32px;
  display: inline;
  position: relative;
  z-index: 2;
  text-transform: uppercase;
  -webkit-transition: all .3s;
  transition: all .3s;
  font-weight: bold;
  padding: 16px 30px;
  font-size: 16px;
  width: 100%;
  cursor: pointer;
  
  &.shadow3_alt {
    transition: .3s;

    &:hover {
      box-shadow: 0 3px 4px rgba(161, 161, 161, 0.4);
    }
  }
`
